'use strict';
const recaptchaManager = require('od-modules/users/recaptcha.js');

Odigeo.defineWidget('remember_me_manager', Odigeo.Widget.extend({
    modelClass: require('./model'),
    viewClass: require('./view'),

    enableRememberMe: function(isEnable) {
        this.view.activateWidget(isEnable && !this.model.socialLogin);
    },

    dealWithErrors: function(data) {
        if (Odigeo.AB.isRecaptchaLoginEnabled) {
            recaptchaManager.gRecaptchaReset(this.model.recaptchaWidgetID);
        }
        const msgError = data.messageError || 'default';
        if (msgError.indexOf('recaptcha') !== -1) {
            this.showGenericError('recaptchaerror');
            this.trackRecaptchaError('odigeo_recaptcha_error_sign-on');
        } else if (msgError === 'remoteError') {
            this.showGenericError('remoteerror');
        } else if (Odigeo._.startsWith(msgError, 'UNL')) {
            this.view._showUnlError();
        } else {
            this.view._showError(this.model.errors[msgError]);
        }
    },

    showLoginError: function(data) {
        if (this.view._isAccountBlocked(data)) {
            this.view.launchAccountBlockedFlow();
        } else {
            this.dealWithErrors(data);
        }
    },

    renderCaptcha: function() {
        this.view.renderCaptcha();
    },

    showGenericError: function(errAttr) {
        this.view.showGenericError(errAttr);
    },

    hideGenericError: function() {
        this.view.hideGenericError();
    },
}));
